const MS_PER_DAY = 1000 * 60 * 60 * 24;
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export function resolveEnjoymentStartDate(
    deadlineIso: string | null | undefined,
    leadDays: number = 0
): string {
    if (!deadlineIso || !ISO_DATE.test(deadlineIso)) return '';

    const [year, month, day] = deadlineIso.split('-').map(Number);
    const deadline = Date.UTC(year, month - 1, day);
    if (Number.isNaN(deadline)) return '';

    return new Date(deadline - leadDays * MS_PER_DAY).toISOString().slice(0, 10);
}

export function addUtcMonths(date: Date, months: number): Date {
    const result = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + months, date.getUTCDate()));
    if (result.getUTCDate() !== date.getUTCDate()) {
        result.setUTCDate(0);
    }
    return result;
}

export function daysUntilIsoDate(
    targetIso: string | null | undefined,
    today: Date = new Date()
): number | null {
    if (!targetIso || !ISO_DATE.test(targetIso)) return null;

    const [year, month, day] = targetIso.split('-').map(Number);
    const target = Date.UTC(year, month - 1, day);
    const reference = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());

    return Math.round((target - reference) / MS_PER_DAY);
}
